import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import DealLeads from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/DealLeads';
import { LEAD_ROLE } from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/leadRoles';

const AbsLeads = ({ row }: ICellProps) => (
  <DealLeads
    groups={ [
      { role: LEAD_ROLE.structuring, leads: row.structuringLeads },
      { role: LEAD_ROLE.joint, leads: row.jointLeads },
    ] }
    fallbackQuery={ { products: row.product?.abbreviation, regions: row.region?.abbreviation } }
  />
);

export default AbsLeads;
